module.exports = __webpack_public_path__ + "eb326395aaf5d701c42a4cb8d404822e.svg";